<fs-dialog>
  <h1 mat-dialog-title>{{ title }}</h1>
  <mat-dialog-content>
    @if (content) {
      <fs-html-renderer [html]="content"></fs-html-renderer>
    }
  </mat-dialog-content>
  <mat-dialog-actions>
    <button
        type="button"
        mat-button
        mat-dialog-close
        color="primary">
      Done
    </button>
  </mat-dialog-actions>
</fs-dialog>